<template>
    <div class="bg-gray rounded-lg pb-3 pt-1 px-3 pb-0 mt-3 overflow-clip cursor-pointer" >
        <div class="flex items-center">
            <h1 class="text-base font-bold leading-tight">{{title}}</h1>
            <div class="ml-auto">
                <b-dropdown variant="link" right toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <span class="flex item-center w-full">
                            <span class="text-gray-1 text-xs">{{filteredBy?.label}} </span> <church-icon class="!w-3 relative -top-1" icon="chevron-down"/>
                        </span>
                    </template>

                    <b-dropdown-item v-for="filter in dateFilter" :key="filter?.value" @click="() => filteredBy = filter">
                        {{filter?.label}}
                    </b-dropdown-item>
                   
                </b-dropdown>
            </div>
        </div>

        <div 
            @click="() => $emit('view')"
            :class="[{'isLoading h-[147px]' : !loaded}]"
            v-node="renderChart" 
            :key="reRender"></div>

        <div class="flex items-center text-xs text-gray-1 mt-2">
            <span class="flex items-center mr-2">
                <span class="w-1.5 h-1.5 rounded-full block bg-blue mr-1"></span> {{totalCompleted}} Complete
            </span>
            <span class="flex items-center ">
                <span class="w-1.5 h-1.5 rounded-full block bg-gray-1 mr-1"></span> {{filteredTaskList?.length}} Total
            </span>
        </div>
    </div>
</template>

<script setup>

import Charts from "@/helpers/charts"
import DateUtils from "@/helpers/dateUtls"
import { dateFilter } from "@/helpers/staticVariables"
import {  computed, defineProps, ref, watch } from "vue"

/* ======== PROPS ====== */
const props = defineProps({
    title : {type : String, default : 'Task'},
    tasks : {type : Array, default : () => []},
    loaded : {type : Boolean, default : false},
    valueColor : {type : String, default : '#3987F0'},
    placeholderColor : {type : String, default : '#DEE0ED'},
    textColor : {type : String, default : '#000'},
    textSize : {type : Number, default : 40},
})

/* ========== STATES ======= */
const renderChart = ref(null)
const reRender = ref(Math.random())
const filteredBy = ref(dateFilter[0])

/* ========= COMPUTED ====== */

/**
 * Filtered task list
 */
const filteredTaskList = computed(() => {
    return props.tasks.filter(task => {
        if(filteredBy.value?.value == 'month') return  DateUtils.isSame({date: task?.date, compareDate : new Date(), unit : 'month', timeZone : null, dateOriginFormat : 'MM/DD/YYYY'})
        if(filteredBy.value?.value == 'quarter') return DateUtils.dateDiff({startDate : task?.date, endDate : new Date(), unit : 'months', timeZone : null, startDateOriginFomat : 'MM/DD/YYYY'}) <= 3
        if(filteredBy.value?.value == 'year') return DateUtils.isSame({date: task?.date, compareDate : new Date(), unit : 'year', timeZone : null, dateOriginFormat : 'MM/DD/YYYY'})
        if(filteredBy.value?.value == 'all') return true

        return true;
    })
})

/**
 * Total completed task
 */
const totalCompleted = computed(() => {
    return filteredTaskList?.value.filter(t => t.is_completed).length
})


/* ========== METHODS ======= */

/**
 * Render Task doughnut chart
 * @param {Array} taskList
 */
const renderTaskDoughnutChart = (taskList) => {
    const serializeArray = JSON.stringify(taskList || [])
    const deSerializeArray = JSON.parse(serializeArray)
    
        const completedTask = [...deSerializeArray.filter(t => t.is_completed)]
        const remainTask = [...deSerializeArray].length - completedTask.length

        console.log(deSerializeArray[0], 'completedTask', completedTask.length, remainTask)

    /**
     * Set default data
     */
    let defaultData = null
    if(!deSerializeArray[0])  defaultData = {a : 100, b : 0}
    

    return Charts.doughnutChart({
        width           : (window.innerWidth - 64) / 2,
        height          : (window.innerWidth - 64) / 2,
        valueColor      : props.valueColor,
        placeholderColor: props.placeholderColor,
        textColor       : props.textColor,
        textSize        : 40,
        radiusWidth     : 15,
        radius          : 70,
        data            : defaultData || {a : remainTask, b : completedTask.length},
        centerTextValue : (defaultData ? 0 : Math.round((completedTask.length / deSerializeArray.length) * 100) )+ '%',
    })
}

/* ========= WATCHER ====== */
/** 
 * Watch task list changes and re-render chart
 */

watch(() => filteredTaskList.value, (tasks) => {
    console.log('tasks watcher', tasks, tasks.length)
    renderChart.value = renderTaskDoughnutChart(tasks)
    reRender.value = Math.random()
}, {deep : true})

</script>